import { useState, useEffect } from "react";
// import Footer from "../Footer";
import Header from "../Header";
import Sidebar from "../Sidebar";
import SidebarIcons from "../SidebarIcons";
import { useSelector } from "react-redux";
import BottomBarIcons from "../BottomBarIcons";
import PropertyMap from "./PropertyMap";
import 'leaflet/dist/leaflet.css';
import './PropertyList.css';
import useGetClientId from "../../hooks/useGetClientId";
import http from "../../api/server";
import { GET_PROPERTIES_LIST } from "../../api/apiPath";
const PropertyList = ({ searchText, propertyName }) => {
	const [hideSidebar, setHideSidebar] = useState(false);
	const [properties, setProperties] = useState([]);

	const [selectedProperty, setSelectedProperty] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setSelectedProperty(null);
	}, []); 

	useEffect(() => {
		setSelectedProperty(null);
	}, [searchText, propertyName]);

	const { userObj } = useSelector((state) => state.user);
	const clientObj = useGetClientId();
	const filteredProperties = properties.filter((property) => {
		const matchesSearch =
			!searchText ||
			property.name?.toLowerCase().includes(searchText.toLowerCase()) ||
			property.address?.toLowerCase().includes(searchText.toLowerCase());

		const matchesPropertyName =
			!propertyName || property.name === propertyName;

		return matchesSearch && matchesPropertyName;
	});
	
	useEffect(() => {
		if (!clientObj?.clientId) return;
		fetchPropertiesList();
	}, [clientObj?.clientId]);

	// const fetchPropertiesList = async () => {
	// 	try {
	// 		const response = await http.get(
	// 			GET_PROPERTIES_LIST + `?clientId=${clientObj?.clientId}`
	// 		);
	// 		if (response.status === 200) {
	// 			const data = await response.json();
	// 			setProperties(data);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching properties:', error);
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// };
	const fetchPropertiesList = async () => {
  try {
    const response = await http.get(
      `${GET_PROPERTIES_LIST}?clientId=${clientObj?.clientId}`
    );

    if (response.status === 200) {
      setProperties(response.data);  
    }
  } catch (error) {
    console.error("Error fetching properties:", error);
  } finally {
    setLoading(false);
  }
};


	const handleSelectProperty = (property) => {
		setSelectedProperty(property);
	};
	return (
		<>
			<Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
			{userObj && (
				// <div className="dashboard_body_main">
				<div>
					{hideSidebar ? (
						<Sidebar
							setHideSidebar={setHideSidebar}
							hideSidebar={hideSidebar}
						/>
					) : (
						<SidebarIcons
							setHideSidebar={setHideSidebar}
							hideSidebar={hideSidebar}
						/>
					)}
					<div className="d-flex flex-column py-1 w-100 mt-2">
						<div className="border-0 w-100">
							{/* <div className="dashboard_header dashboard_header_inspection d-flex" style={{ textAlign: "justify" }}>
								<div>
									<h2 className="mb-0">Property List</h2>
									<p className="header-description">
										View and manage all properties
									</p>
								</div>
							</div> */}

							<div className="row g-0 property-list-container">
								{/* Property List */}
								<div className="col-md-4 border-end">
									<div className="h-100 p-3" style={{ backgroundColor: '#f8f9fa' }}>
										{/* <div className="dashboard_header dashboard_header_inspection d-flex" style={{ textAlign: "justify" }}>
													<div>
														<h2 className="mb-0">Property List</h2>
														<p className="header-description">
															Browse and explore property locations
														</p>
													</div>
												</div> */}
										{loading ? (
											<div className="text-center mt-5">
												<div className="spinner-border text-primary" role="status">
													<span className="visually-hidden">Loading...</span>
												</div>
												<p className="mt-2 text-muted">Loading properties...</p>
											</div>
										) : properties.length === 0 ? (
											<div className="text-center text-muted mt-5">
												<i className="fas fa-building fa-3x mb-3 text-muted"></i>
												<p className="mb-1">No properties found.</p>
											</div>
										) : (
											<div >

												{/* <div className="mb-3">
													<h6 className="text-muted mb-0">Properties ({properties.length})</h6>
												</div> */}
												<div className="property-list-scroll">
													<div className="d-flex flex-column gap-3">
														{filteredProperties.length > 0 && filteredProperties?.map(property => (
															<div
																key={property.propertyMasterId}
																onClick={() => handleSelectProperty(property)}
																className={`property-card-modern ${selectedProperty?.propertyMasterId === property.propertyMasterId
																	? 'property-selected'
																	: ''
																	}`}
															>
																<div className="property-card-content">
																	<div className="property-header">
																		<div className="property-avatar">
																			<i className="fas fa-building"></i>
																		</div>
																		<div className="property-info">
																			<h6 className="property-title">{property.name}</h6>
																			<div className="property-meta">
																				{property.address && (
																					<span className="property-address">
																						<i className="fas fa-map-marker-alt"></i>
																						{property.address}
																					</span>
																				)}
																			</div>
																			{property.latitude && property.longitude && (
																				<div className="property-coordinates">
																					<small>{parseFloat(property.latitude)}, {parseFloat(property.longitude)}</small>
																				</div>
																			)}
																		</div>
																		<div className="property-status">
																			{/* {property.latitude && property.longitude ? (
																				<span className="status-badge status-active">
																					<i className="fas fa-map-pin"></i>
																					Located
																				</span>
																			)
																			 : (
																				<span className="status-badge status-pending">
																					<i className="fas fa-clock"></i>
																					Pending
																				</span>
																			)
																			} */}
																			{property.latitude && property.longitude && (
																				<span className="status-badge status-active">
																					<i className="fas fa-map-pin"></i>
																					Located
																				</span>
																			)}
																		</div>
																	</div>

																</div>
															</div>
														))}
													</div>
												</div>

											</div>
										)}
									</div>
								</div>

								{/* Map */}
								<div className="col-md-8">
									<div className="h-100">
										<PropertyMap
											properties={filteredProperties}
											onSelectProperty={handleSelectProperty}
											selectedPropertyId={selectedProperty?.propertyMasterId}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* <Footer /> */}
					<div className="bottom-bar-spacing"></div>
					<BottomBarIcons />
				</div>
			)}
		</>
	)
}

export default PropertyList
